import { SET_PAYCHECKS_LIST } from "./types";
import { setError } from "./errorActions";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getPaychecksList = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/paychecks`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_PAYCHECKS_LIST, payload: response.data.paychecks });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getPaycheckFile = (paycheckID) => async (dispatch) => {
    const target = window.open("", "_blank");

    if (!target) {
        dispatch(setError(null, "---", ["Przeglądarka zablokowała otwarcie pliku"]));
        return;
    }

    try {
        target.document.title = "Przygotowywanie pliku PDF...";

        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/paychecks/pdf/${paycheckID}`, {
                responseType: "blob",
                headers: {
                    "Accept": "application/pdf",
                    "Content-Type": "application/pdf",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            if (target.closed) {
                return;
            }

            const url = URL.createObjectURL(response.data);
            target.location.replace(url);
        }
    }
    catch (error) {
        if (!target.closed) {
            target.close();
        }

        errorHandler(error, null);
    }
};